import { isSimulatedVoiceTask, isVoiceTask, useActiveTask } from "@/sdk";

type ActiveTask = ReturnType<typeof useActiveTask>;

export type OverlayPhase = "hidden" | "standby" | "live";

export function derivePhase(task: ActiveTask): OverlayPhase {
    if (!task || !isVoiceTask(task) || isSimulatedVoiceTask(task)) return "hidden";
    if (task.ivrInfo?.isWarmHandoffEnabled?.toLowerCase() !== "true") return "hidden";
    if (task.conferenceStarted) return "live";
    if (task.status === "pending" || task.status === "assigned") return "standby";
    return "hidden";
}
